import React from "react";

import parse, { domToReact } from "html-react-parser";

import { LazyLoadImage, Link } from "components";

export const truncateString = (text, length) => {
  if (text.length > length) {
    return `${text.substr(0, length).split(" ").slice(0, -1).join(" ")}...`;
  }
  return text;
};

export const gentlyTruncateString = (text, length) => {
  if (text.length > length) {
    return `${text.substr(0, length).split(" ").join(" ")}...`;
  }
  return text;
};

export const cleanHtml = (text, user, imageClickCallback) => {
  const options = {
    replace: ({ attribs, children }) => {
      if (!attribs) {
        return;
      }

      if (attribs.href && attribs.href.includes(process.env.REACT_APP_FARM_URL)) {
        return <Link to={attribs.href.replace(process.env.REACT_APP_FARM_URL, "")}>{domToReact(children, options)}</Link>;
      }

      if (attribs.src) {
        return (
          <LazyLoadImage
            width={attribs.width}
            height={attribs.height}
            src={attribs.src}
            className="zoom-image"
            onClick={() => imageClickCallback(attribs.src)}
          />
        );
      }
    },
  };

  const cleanTextAsDom = parse(text.replaceAll("<p>&nbsp;</p>", "").replaceAll('<p dir="ltr">&nbsp;</p>', ""), options);

  return Array.isArray(cleanTextAsDom) ? cleanTextAsDom : [cleanTextAsDom];
};

export const stripHtml = (text) => (typeof text === "string" ? text.replace(/<[^>]*>?/gm, "") : text);

// camelize kebabs ("i-am-a-kebab" => "iAmAKebab")
export const camelize = (s) => s.replace(/-./g, (x) => x[1].toUpperCase());

// camelize strings ("I am a string" => "iAmAString")
export const camelizeString = (s) => s.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, c) => c.toUpperCase());

export const reverseCamelizeString = (string) =>
  string
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .trim();
